import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      //
      path: '/',
      name: 'planManage',
      meta: {
        menu: '/planManage',
        keep: true
      },
      component: resolve => require(['@/pages/agent/planManage'], resolve)
    }, {
      // 计划书管理
      path: '/planManage',
      name: 'planManage',
      meta: {
        menu: '/planManage',
        keep: true
      },
      component: resolve => require(['@/pages/agent/planManage'], resolve)
    },
    {
      // 用户管理
      path: '/userManage',
      name: 'userManage',
      meta: {
        menu: '/userManage',
        keep: true
      },
      component: resolve => require(['@/pages/agent/userManage'], resolve)
    },
    {
      // 发布管理
      path: '/publishManage',
      name: 'publishManage',
      meta: {
        menu: '/publishManage',
        keep: true
      },
      component: resolve => require(['@/pages/agent/publishManage'], resolve)
    },
    {
      // 发布管理详情
      path: '/publishManageDetail',
      name: 'publishManageDetail',
      meta: {
        menu: '/publishManage'
      },
      component: resolve => require(['@/pages/agent/publishManage/detail'], resolve)
    },
    {
      // 发布管理新增
      path: '/addPublishManage',
      name: 'addPublishManage',
      meta: {
        menu: '/publishManage'
      },
      component: resolve => require(['@/pages/agent/publishManage/detail'], resolve)
    },
    {
      // 问卷调查管理
      path: '/questionnaireManage',
      name: 'questionnaireManage',
      meta: {
        menu: '/questionnaireManage',
        keep: true
      },
      component: resolve => require(['@/pages/agent/questionnaireManage'], resolve)
    },
    {
      // 问卷调查管理-详情
      path: '/questionnaireManageDetail/:versionId',
      name: 'questionnaireManageDetail',
      meta: {
        menu: '/questionnaireManage'
      },
      component: resolve => require(['@/pages/agent/questionnaireManage/detail'], resolve)
    },
    {
      // 位置签到
      path: '/locationCheckIn',
      name: 'locationCheckIn',
      meta: {
        menu: '/locationCheckIn',
        keep: true
      },
      component: resolve => require(['@/pages/agent/locationCheckIn'], resolve)
    },
    {
      // 位置签到-详情
      path: '/locationCheckInDetail/:topicId',
      name: 'locationCheckInDetail',
      meta: {
        menu: '/locationCheckIn'
      },
      component: resolve => require(['@/pages/agent/locationCheckIn/detail'], resolve)
    },
    // 客户APP
    {
      // 客户管理
      path: '/customer',
      name: 'customerManage',
      meta: {
        menu: '/customer/customerManage',
        keep: true
      },
      component: resolve => require(['@/pages/customer/customerManage'], resolve)
    },
    {
      // 客户管理
      path: '/customer/customerManage',
      name: 'customerManage',
      meta: {
        menu: '/customer/customerManage',
        keep: true
      },
      component: resolve => require(['@/pages/customer/customerManage'], resolve)
    },
    {
      // 客户管理-详情
      path: '/customer/information/:customerAgentId/:step',
      name: 'customerInformation',
      meta: {
        menu: '/customer/customerManage',
        keep: true
      },
      component: resolve => require(['@/pages/customer/customerManage/detail'], resolve)
    },
    {
      // 客户管理-保单列表-详情
      path: '/customer/customerManage/policyDetail/:policyId',
      name: 'customerManagePolicyDetail',
      meta: {
        menu: '/customer/customerManage'
      },
      component: resolve => require(['@/pages/customer/customerManage/policyDetail'], resolve)
    },
    {
      // 保单录入
      path: '/customer/policy',
      name: 'policy',
      meta: {
        menu: '/customer/policy',
        keep: true
      },
      component: resolve => require(['@/pages/customer/policy'], resolve)
    },
    {
      // 保单录入-详情
      path: '/customer/policyInput',
      name: 'policyInput',
      meta: {
        menu: '/customer/policy'
      },
      component: resolve => require(['@/pages/customer/policy/detail'], resolve)
    },
    {
      // 保单查询
      path: '/customer/policyQuery',
      name: 'policyQuery',
      meta: {
        menu: '/customer/policyQuery',
        keep: true
      },
      component: resolve => require(['@/pages/customer/policyQuery'], resolve)
    },
    {
      // 保单查询-详情
      path: '/customer/policyDetail/:policyId',
      name: 'policyDetail',
      meta: {
        menu: '/customer/policyQuery'
      },
      component: resolve => require(['@/pages/customer/policyQuery/detail'], resolve)
    },
    {
      // 消息通知
      path: '/customer/message',
      name: 'message',
      meta: {
        menu: '/customer/message',
        keep: true
      },
      component: resolve => require(['@/pages/customer/message'], resolve)
    },
    {
      // 消息通知-详情
      path: '/customer/messageDetail',
      name: 'messageDetail',
      meta: {
        menu: '/customer/message'
      },
      component: resolve => require(['@/pages/customer/message/detail'], resolve)
    },
  ]
})

// 解决懒加载导致的找不到js的偶现问题
router.onError((error) => {
  const pattern = /Loading chunk (\d)+ failed/g
  const isChunkLoadFailed = error.message.match(pattern)
  const targetPath = router.history.pending.fullPath
  if (isChunkLoadFailed) {
    router.replace(targetPath)
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js